import React from 'react';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';

import AssetUploadOnS3, { AssetType } from '../baseui/input/assetUploadOnS3';

interface AssetUploadInputOnS3Props {
	name: any;
	assetType: AssetType;
	control: any;
	setShowLoader: any;
	defaultValue: any;
	downloadFile?: boolean;
	link?: string;
	displayText?: string;
	maxFileSize?: number;
	subFolder?: string;
	zupeeUserId?: number;
	usePresignedUrl?: boolean;
}

const AssetUploadInputOnS3: React.FC<AssetUploadInputOnS3Props> = (props) => {
	const { name, assetType, control, setShowLoader, defaultValue } = props;

	return (
		<Controller
			render={({ field: { onChange, value } }) => (
				<AssetUploadOnS3 {...props} assetType={assetType} onChange={onChange} value={value} setShowLoader={setShowLoader} />
			)}
			control={control}
			name={name}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default AssetUploadInputOnS3;
